import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=79272b76&scoped=true&"
import script from "./examList.vue?vue&type=script&lang=js&"
export * from "./examList.vue?vue&type=script&lang=js&"
import style0 from "./examList.vue?vue&type=style&index=0&id=79272b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79272b76",
  null
  
)

export default component.exports